module.exports = __webpack_public_path__ + "static/assets/b9d47ac3da4be9c388c4324351c88ec1.svg";